import { useMemo } from 'react';

import { L3_PATHS } from 'Deer/constants/routes';
import { useLocation, useRouteMatch } from 'react-router-dom';
import { checkIntentLandingPagesFeatureEnabled, checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { routes } from 'constants/routes';

const useDeerTeamBasedReviewRoute = () => {
  const location = useLocation();
  const isTalentPlanningPage = location.pathname.includes(routes.performanceReview.talentPlanning);

  const isReviewViewReviewManagePage = useRouteMatch({
    path: L3_PATHS.team.view.review.manage,
    exact: true,
  });

  const isReviewViewCalibrationPage = useRouteMatch({
    path: L3_PATHS.team.view.review.calibrationView,
    exact: true,
  });

  return useMemo(() => {
    if (!checkNewNavEnabled()) {
      return routes.performanceReview.manage;
    }

    if (isTalentPlanningPage) {
      if (isReviewViewReviewManagePage || isReviewViewCalibrationPage) {
        if (checkIntentLandingPagesFeatureEnabled()) {
          return L3_PATHS.team.view.review.calibratedResults;
        }
        return L3_PATHS.team.view.review.manage;
      }
      // else company talent planning page: so go to new nav company
      if (checkIntentLandingPagesFeatureEnabled()) {
        return L3_PATHS.company.review.calibratedResults;
      }
      return L3_PATHS.company.review.manage;
    }
    return location.pathname;
  }, [isReviewViewCalibrationPage, isReviewViewReviewManagePage, isTalentPlanningPage, location.pathname]);
};

export default useDeerTeamBasedReviewRoute;
